import { Box, Typography } from "@mui/material";

import EmptyState from "../ui/emptyState";
import LoadingState from "../ui/loadingState";
import React from "react";

type Props = {
  isLoading: boolean;
  isEmpty: boolean;
  emptyText: string;
  height?: number;
};

const ChartContainer: React.FC<React.PropsWithChildren<Props>> = ({
  isLoading,
  isEmpty,
  emptyText,
  height,
  children,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: height,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      {isLoading || isEmpty ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100%"
          width="100%"
          paddingX={4}
        >
          {isLoading ? (
            <LoadingState maxHeight="80%" maxWidth="80%" />
          ) : (
            <>
              <EmptyState maxHeight="50%" maxWidth="80%" />
              {/* Mensagem de estado vazio é texto para ler, não hint: `ink-40`
                  dá 2,67:1 no light. Rótulo mono em `text.secondary` (ink-60),
                  igual aos vazios de declaração e statement. */}
              <Typography
                variant="labelMono"
                color="text.secondary"
                textAlign="center"
                sx={{ padding: 2 }}
              >
                {emptyText}
              </Typography>
            </>
          )}
        </Box>
      ) : (
        children
      )}
    </Box>
  );
};

export default ChartContainer;
